<template>
  <v-row class="px-4 py-2">
    <v-col cols="12">
      <v-textarea
        no-resize
        outlined
        label="SMS Text"
        v-model="sms_text"
        placeholder=" "
        :rules="[!isChecked && validatingForm ? () => true : required]"
        hide-details
        :append-icon="isDiff('sms_text') ? 'mdi-alert-octagram' : ''"
      />
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify'
import orderBy from 'lodash.orderby'
import { required } from '@/common/validationRules'

const getSet = prop => ({
  get() {
    return this.form[this.uuid].data[prop]
  },

  set(v) {
    let value = v
    if (!value || !value.length) {
      value = null
    }
    const form = Object.assign({}, this.form)
    form[this.uuid].data[prop] = value
    this.$store.dispatch('smsMessage/updateForm', {
      uuid: this.uuid,
      prop,
      value
    })
  }
})

export default {
  name: 'SmsMessageTextField',

  props: {
    item: Object,
    uuid: String,
    itemData: Object,
    validatingForm: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    form: get('smsMessage/form'),

    model: get('smsMessage/model'),

    sms_text: {
      ...getSet('sms_text')
    },

    smsTemplates() {
      return orderBy([], ['text'], ['asc'])
    },

    currentTrip() {
      return this.model?.trips?.find(x => x?.trip_uuid === this.uuid)
    },

    isChecked() {
      return this.form[this.uuid]._checked
    }
  },

  methods: {
    isDiff(prop) {
      if (!this.currentTrip) return false
      const currentProp = this.currentTrip.data[prop] || null
      const formProp = this.form[this.uuid].data[prop] || null
      return currentProp !== formProp
    }
  }
}
</script>
